import React, { useState, useEffect, useRef } from 'react';
import LoadingComponent from '@/components/common/LoadingComponent';
import ErrorState from '@/components/common/ErrorStateComponent';
import { apiCall } from '@/api/apiCall';
import { useQueue } from '@/context/QueueContext';
import ReusableKPIChartV2 from '@/components/BoardPack/components/charts/ReusableKPIChartV2';

const KpiChart12NEW = ({ year = "", month = "", monthNumber = "", contract = "", page = null }) => {
  const { enqueue } = useQueue();

  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
     const hasFetchedRef = useRef(false);
  

  const transformApiData = (apiData) => {
    if (!apiData?.data) {
      return [];
    }
    
    const data = apiData.data;
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    // Get the keys dynamically from page config labels
    const revenueKey = page?.labels?.revenue || 'Revenue';
    const transactionKey = page?.labels?.transaction || 'Units Rented';
    const atvKey = page?.labels?.atv || 'Price per Sq Mtr';
    const alsKey = page?.labels?.als || 'Occupancy%';
    
    // Check if the keys exist in data
    if (!data[revenueKey]) {
      console.error(`Key "${revenueKey}" not found in data`);
      return [];
    }
    
    const transformedData = [];
    
    // Get all available years from the revenue data
    const availableYears = Object.keys(data[revenueKey]).filter(key => key !== 'isPercent');
    
    // Process each year dynamically
    availableYears.forEach(yearValue => {
      months.forEach(monthName => {
        // Check if data exists for this month
        if (data[revenueKey][yearValue] && data[revenueKey][yearValue][monthName]) {
          let alsValue = 0;
          
          // Safely get ALS value
          if (data[alsKey] && data[alsKey][yearValue] && data[alsKey][yearValue][monthName]) {
            const rawAlsValue = data[alsKey][yearValue][monthName];
            
            // Check if it's a percentage string and convert
            if (data[alsKey]?.isPercent && typeof rawAlsValue === 'string') {
              alsValue = parseFloat(rawAlsValue.replace('%', ''));
            } else {
              alsValue = parseFloat(String(rawAlsValue).replace(/,/g, ''));
            }
          }
          
          // Safely parse all values
          const revenueValue = data[revenueKey][yearValue][monthName] 
            ? parseFloat(String(data[revenueKey][yearValue][monthName]).replace(/,/g, ''))
            : 0;
            
          const transactionValue = data[transactionKey] && data[transactionKey][yearValue] && data[transactionKey][yearValue][monthName]
            ? parseFloat(String(data[transactionKey][yearValue][monthName]).replace(/,/g, ''))
            : 0;
            
          const atvValue = data[atvKey] && data[atvKey][yearValue] && data[atvKey][yearValue][monthName]
            ? parseFloat(String(data[atvKey][yearValue][monthName]).replace(/,/g, ''))
            : 0;
          
          transformedData.push({
            month: `${monthName}-${yearValue}`,
            year: yearValue,
            revenue: revenueValue,
            transaction: transactionValue,
            atv: atvValue,
            als: alsValue,
          });
        }
      });
    });
    
    return transformedData;
  };

   useEffect(() => {
    //   if (!year || !month || !contract) return;
    //   if (hasFetchedRef.current) return;
    
    //   hasFetchedRef.current = true;
      fetchData();
    }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Build params dynamically from page config
      const params = { ...(page?.params || {}) };
      
      // Replace placeholders with actual values
      Object.keys(params).forEach(key => {
        if (params[key] === '{{year}}') {
          params[key] = year;
        } else if (params[key] === '{{month}}') {
          params[key] = month;
        } else if (params[key] === '{{contract}}') {
          params[key] = contract;
        }
      });

      const response = {
    "success": true,
    "message": "data fetched successfully",
    "server": "BI",
    "cube": "REAL_ESTATE_DATA_FOR_BI",
    "data": {
        "Revenue": {
            "2024": {
                "Jan": "1,774,051",
                "Feb": "1,773,525",
                "Mar": "1,798,386",
                "Apr": "1,818,417",
                "May": "1,848,959",
                "Jun": "1,848,959",
                "Jul": "1,859,359",
                "Aug": "1,867,542",
                "Sep": "1,868,123",
                "Oct": "1,867,542",
                "Nov": "1,867,542",
                "Dec": "1,843,291"
            },
            "2025": {
                "Jan": "1,862,811",
                "Feb": "1,875,406",
                "Mar": "1,905,480",
                "Apr": "1,917,750"
            }
        },
        "Units Rented": {
            "2024": {
                "Jan": "229",
                "Feb": "228",
                "Mar": "235",
                "Apr": "234",
                "May": "241",
                "Jun": "241",
                "Jul": "245",
                "Aug": "247",
                "Sep": "247",
                "Oct": "247",
                "Nov": "247",
                "Dec": "239"
            },
            "2025": {
                "Jan": "222",
                "Feb": "229",
                "Mar": "236",
                "Apr": "233"
            }
        },
        "Price per Sq Mtr": {
            "2024": {
                "Jan": "139",
                "Feb": "139",
                "Mar": "139",
                "Apr": "141",
                "May": "141",
                "Jun": "141",
                "Jul": "140",
                "Aug": "140",
                "Sep": "141",
                "Oct": "140",
                "Nov": "140",
                "Dec": "141"
            },
            "2025": {
                "Jan": "148",
                "Feb": "147",
                "Mar": "147",
                "Apr": "148"
            }
        },
        "Occupancy%": {
            "2024": {
                "Jan": "88%",
                "Feb": "88%",
                "Mar": "90%",
                "Apr": "91%",
                "May": "94%",
                "Jun": "94%",
                "Jul": "95%",
                "Aug": "96%",
                "Sep": "96%",
                "Oct": "96%",
                "Nov": "96%",
                "Dec": "90%"
            },
            "isPercent": true,
            "2025": {
                "Jan": "86%",
                "Feb": "88%",
                "Mar": "90%",
                "Apr": "91%"
            }
        }
    }
};

      if (response?.success) {
        const transformed = transformApiData(response);
        setChartData(transformed);
      } else {
        setError(response?.message || "Failed to load data. Please try again later.");
      }
    } catch (err) {
      setError(err?.message || "Failed to load data. Please try again later.");
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} onRetry={fetchData} />;

  // ✅ Dynamic Y-axis formatters - No decimals, just whole numbers
  // Dynamic Y-axis formatters based on page config
const yAxisFormatters = {
  left: page?.yAxisFormatters?.left 
    ? (value) => {
        // Revenue ke liye - thousands mein, without decimals
        if (value >= 1000) {
          return Math.round(value / 1000) + 'K';
        }
        return Math.round(value);
      }
    : (value) => Math.round(value).toLocaleString(),
  right: page?.yAxisFormatters?.right 
    ? (value) => Math.round(value)  // ✅ No decimals, just round number
    : (value) => Math.round(value).toLocaleString()
};

  return (
    <ReusableKPIChartV2
      chartData={chartData}
      title={page?.title}
      subtitle={page?.subtitle}
      chartTitle={page?.in_chart_content_line_1}
      colors={page?.colors}
      labels={page?.labels}
      showDataLabels={page?.showDataLabels ? true : false}
      yAxisFormatters={yAxisFormatters}
    />
  );
};

export default KpiChart12NEW;